<template>
  <div class="vue-card-stack__wrapper">
    <teleport to="body">
      <div v-if="showClone" class="card-clone" :style="cloneStyle" @transitionend="onTransitionEnd">
        <div class="background-glow pulsing-glow" :style="{ '--glow-color': expandedData.backgroundColor }"></div>

        <v-card :style="cloneCardStyle" class="d-flex flex-column glass-card">
          <v-toolbar v-if="!hasHeroData" flat color="transparent" dark>
            <v-toolbar-title class="font-weight-bold text-h5">{{
              expandedData.exercise ? expandedData.exercise.title : expandedData.execution.title
            }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click.stop="closeClone"><v-icon>mdi-close</v-icon></v-btn>
          </v-toolbar>
          <v-btn v-else icon @click.stop="closeClone" class="clone-close-btn" dark><v-icon>mdi-close</v-icon></v-btn>

          <v-card-text class="flex-grow-1 overflow-y-auto pa-0">
            <div v-if="hasHeroData" class="hero-header" :style="heroBackgroundStyle">
              <div class="hero-content">
                <h3 class="font-weight-bold display-1 white--text">{{ expandedData.execution.title }}</h3>
                <p class="text-subtitle-1 mt-1 white--text" style="opacity: 0.8">
                  {{ $moment(expandedData.execution.createdAt).format("dd, DD. MMMM YY") }}
                </p>
              </div>
            </div>

            <div class="content-wrapper pa-4">
              <div v-if="expandedData.summary">
                <v-row>
                  <v-col cols="12" md="5" class="animated-item" style="--delay: 0.1s">
                    <MuscleDiagram
                      cols="5"
                      justify="space-between"
                      :exercises="expandedData.exercise"
                      :activeClasses="expandedData.exercise.tags.map((tag) => tag.class)"
                      background="rgba(255, 255, 255, 0.05)"
                      :hideTagWindows="true"
                      borderRadius="16px" />
                    <h4 class="font-weight-bold mt-8 mb-4 white--text">Deine Bestleistungen</h4>

                       
                    <div class="personal-best-card mb-4">
                                         
                      <div class="best-card-icon trophy"><v-icon large color="amber">mdi-trophy</v-icon></div>

                                         
                      <div>
                                              <span class="font-weight-bold white--text">Maximales Gewicht</span>
                        <p class="text-h4 font-weight-bold mb-0 mt-1 white--text">
                          {{ expandedData.summary.maxWeightStep.weight }} kg x {{ expandedData.summary.maxWeightStep.reps }}
                        </p>

                                             
                        <span class="text-caption text-muted">{{ $moment(expandedData.summary.maxWeightStep.date).fromNow() }}</span>

                                           
                      </div>

                                       
                    </div>

                                     
                    <div class="personal-best-card" v-if="expandedData.summary.maxVolumeStep">
                                         
                      <div class="best-card-icon volume"><v-icon large color="#64b5f6">mdi-fire</v-icon></div>

                                         
                      <div>
                                              <span class="font-weight-bold white--text">Maximales Volumen</span>

                                             
                        <p class="text-h4 font-weight-bold mb-0 mt-1 white--text">
                          {{ expandedData.summary.maxVolumeStep.weight * expandedData.summary.maxVolumeStep.reps }} kg      
                        </p>

                                             
                        <span class="text-caption text-muted"
                          >{{ expandedData.summary.maxVolumeStep.weight }}kg x {{ expandedData.summary.maxVolumeStep.reps }} Wdh<br />{{
                            $moment(expandedData.summary.maxVolumeStep.date).fromNow()
                          }}</span
                        >

                                           
                      </div>

                                       
                    </div>
                  </v-col>

                  <v-col cols="12" md="7" class="animated-item" style="--delay: 0.2s">
                    <div class="d-flex justify-space-between align-center mt-8 mb-2">
                      <h4 class="font-weight-bold white--text">Fortschritt</h4>
                      <v-chip-group v-model="chartMode" mandatory active-class="primary">
                        <v-chip small value="volume">Volumen</v-chip>
                        <v-chip small value="weight">Max. Gewicht</v-chip>
                      </v-chip-group>
                    </div>
                    <apexchart
                      v-if="chartData"
                      ref="progressChart"
                      class="mt-2 chart-container"
                      type="area"
                      height="350"
                      :options="chartOptions"
                      :series="chartData[chartMode]"></apexchart>
                    <p v-else class="text-center text-muted mt-10">Nicht genügend Daten für den Graphen.</p>
                  </v-col>
                </v-row>
              </div>

              <div v-else-if="expandedData.execution">
                <v-row>
                  <v-col cols="12" class="animated-item" style="--delay: 0.1s">
                    <v-row>
                      <v-col cols="4" class="pr-1">
                        <div class="stat-card-small">
                          <div class="stat-emoji-small">⏱️</div>
                          <div class="text-center">
                            <div class="stat-value-small">{{ formatDuration(expandedData.execution.duration) }}</div>
                            <div class="stat-label-small">Dauer</div>
                          </div>
                        </div>
                      </v-col>
                      <v-col cols="4" class="px-1">
                        <div class="stat-card-small">
                          <div class="stat-emoji-small">🏋️‍♂️</div>
                          <div class="text-center">
                            <div class="stat-value-small">{{ expandedData.execution.liftedWeight }}</div>
                            <div class="stat-label-small">Volumen (kg)</div>
                          </div>
                        </div>
                      </v-col>
                      <v-col cols="4" class="pl-1">
                        <div class="stat-card-small">
                          <div class="stat-emoji-small">🔥</div>
                          <div class="text-center">
                            <div class="stat-value-small">{{ expandedData.execution.caloriesBurned }}</div>
                            <div class="stat-label-small">Kalorien</div>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col
                    cols="12"
                    class="animated-item"
                    style="--delay: 0.2s"
                    v-if="expandedData.execution.records && expandedData.execution.records.length">
                    <h4 class="font-weight-bold mt-8 mb-4 white--text">🏆 Rekorde dieser Session</h4>
                    <v-slide-group dark>
                      <v-slide-item v-for="(pr, index) in expandedData.execution.records" :key="index">
                        <v-card class="pr-card my-2 mr-2">
                          <div class="pr-title">{{ pr.exerciseTitle }}</div>
                          <div class="pr-type">{{ pr.type }}</div>
                          <div class="pr-values">
                            <span class="old-value">{{ pr.oldValue }}</span>
                            <span class="mx-2">→</span>
                            <span class="new-value">{{ pr.newValue }}</span>
                          </div>
                        </v-card>
                      </v-slide-item>
                    </v-slide-group>
                  </v-col>
                  <v-col cols="12" class="animated-item" style="--delay: 0.3s">
                    <h4 class="font-weight-bold mt-8 mb-4 white--text">Ausgeführte Übungen</h4>
                    <v-expansion-panels flat dark class="custom-panels">
                      <v-expansion-panel v-for="exercise in sessionExercises" :key="exercise.id">
                        <v-expansion-panel-header>
                          <v-row align="center" no-gutters>
                            <v-col cols="auto" class="mr-4">
                              <v-avatar rounded size="56" color="rgba(255, 255, 255, 0.1)">
                                <v-img :src="getImageForExercise(getExercise(exercise.id))" position="top center"></v-img>
                              </v-avatar>
                            </v-col>
                            <v-col>
                              <p class="font-weight-bold white--text mb-0 text-subtitle-1">
                                {{ getExercise(exercise.id) ? getExercise(exercise.id).title : "Unbekannte Übung" }}
                              </p>
                              <span class="text-caption text-muted"> {{ exercise.sets.length }} Sätze ・ {{ exercise.totalWeight }} kg Volumen </span>
                            </v-col>
                          </v-row>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-simple-table dense class="mt-2 transparent-table">
                            <thead>
                              <tr>
                                <th class="text-left">Satz</th>
                                <th class="text-left">Gewicht</th>
                                <th class="text-left">Wdh.</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="step in exercise.sets" :key="step._id">
                                <td>{{ step.set }}</td>
                                <td>{{ step.weight }} kg</td>
                                <td>{{ step.reps }}</td>
                              </tr>
                            </tbody>
                          </v-simple-table>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-col>
                </v-row>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </div>
    </teleport>

    <div class="vue-card-stack__stack" :style="{ height: containerHeight, width: containerWidth }">
      <div
        class="vue-card-stack__card"
        v-for="(card, cardIndex) in stack.slice(0, _maxVisibleCards)"
        :key="card._id"
        :style="getCardStyle(card)"
        @click="!isDragging && expandCard(cardIndex, $event)">
        <div class="card-content-wrapper" :class="{ 'is-top-card': cardIndex === 0 }" :style="{ '--glow-color': card.backgroundColor }">
          <v-card dark class="rounded-xl fill-height card-shine-effect" :style="getCardBackground(card, cardIndex)">
            <div v-if="exercises" class="d-flex flex-column pa-5 fill-height">
              <v-card-title class="font-weight-bold white--text pa-0 text-h5 text-on-image">
                {{ card.exercise.title }}
              </v-card-title>
              <v-spacer></v-spacer>
              <v-card-text class="pa-0 text-on-image" v-if="card.summary">
                <v-row no-gutters>
                  <v-col class="text-center">
                    <v-icon>mdi-trophy-award</v-icon>
                    <div class="font-weight-bold text-subtitle-1">{{ card.summary.maxWeightStep.weight }} kg</div>
                  </v-col>
                  <v-col class="text-center">
                    <v-icon>mdi-fire</v-icon>
                    <div class="font-weight-bold text-subtitle-1">{{ card.summary.maxVolumeStep.weight * card.summary.maxVolumeStep.reps }} kg</div>
                  </v-col>
                </v-row>
              </v-card-text>
            </div>

            <div v-else class="d-flex flex-column pa-5 fill-height">
              <v-row no-gutters>
                <v-col cols="9">
                  <v-card-title class="font-weight-bold white--text pa-0 text-h5">
                    {{ card.execution.title }}
                  </v-card-title>
                  <v-card-subtitle class="pa-0 mt-1">
                    {{ $moment(card.execution.createdAt).format("dd, DD. MMM YY") }}
                  </v-card-subtitle>
                </v-col>
              </v-row>
              <v-spacer></v-spacer>
              <v-card-text class="pa-0">
                <v-row no-gutters>
                  <v-col class="text-center">
                    <v-icon large>mdi-clock-time-eight</v-icon>
                    <div class="font-weight-bold text-subtitle-1">{{ formatDuration(card.execution.duration) }}</div>
                  </v-col>
                  <v-col class="text-center">
                    <v-icon large>mdi-weight-lifter</v-icon>
                    <div class="font-weight-bold text-subtitle-1">{{ card.execution.liftedWeight }} kg</div>
                  </v-col>
                  <v-col class="text-center">
                    <v-icon large>mdi-fire</v-icon>
                    <div class="font-weight-bold text-subtitle-1">{{ card.execution.caloriesBurned }} kcal</div>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-img :src="card.img" contain height="70" width="70" class="verlauf-card-icon"></v-img>
            </div>
          </v-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { debounce } from "./utils/debounce"
import { mapGetters, mapActions } from "vuex"
import MuscleDiagram from "../PlanRunInteractiveHuman.vue"
import MetricCard from "./metricCard.vue"

export default {
  name: "TrainingsHubCardStack",
  components: { MuscleDiagram, MetricCard },
  props: {
    exercises: { type: Boolean, default: false },
    cards: { type: Array, default: () => [] },
    cardHeight: { type: Number, default: 250 },
    cardWidth: { default: "100%" },
    stackWidth: { type: [Number, String], default: null },
    sensitivity: { type: Number, default: 0.25 },
    maxVisibleCards: { type: Number, default: 3 },
    scaleMultiplier: { type: Number, default: 0.5 },
    speed: { type: Number, default: 0.2 },
    paddingHorizontal: { type: Number, default: 0 },
    paddingVertical: { type: Number, default: 20 },
  },
  data: () => ({
    stack: [],
    width: 0,
    activeCardIndex: 0,
    isDragging: false,
    dragStartY: 0,
    isDraggingDown: false,
    showClone: false,
    isClosing: false,
    cloneStyle: {},
    cloneCardStyle: {},
    originalCloneStyle: {},
    expandedData: {},
    dragThreshold: 10,
    chartMode: "volume",
  }),
  watch: {
    chartMode(newMode) {
      if (!this.$refs.progressChart || !this.chartData) {
        return
      }
      const newSeries = this.chartData[newMode]
      const newOptions = this.chartOptions
      this.$refs.progressChart.updateOptions(newOptions)
      this.$refs.progressChart.updateSeries(newSeries, true)
    },
  },
  mounted() {
    this.init()
    window.addEventListener("resize", this.handleResize)
    document.addEventListener(this.touchEndEvent, this.onTouchEnd)
    this.$el.addEventListener(this.touchStartEvent, this.onTouchStart)
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize)
    document.removeEventListener(this.touchEndEvent, this.onTouchEnd)
    this.$el.removeEventListener(this.touchStartEvent, this.onTouchStart)
    document.removeEventListener(this.dragEvent, this.onDrag)
  },
  computed: {
    ...mapGetters("deviceStore", ["exerciseList"]),
    hasHeroData() {
      return this.expandedData.execution && (this.expandedData.execution.fixedVisualization || this.expandedData.img)
    },
    heroBackgroundStyle() {
      if (!this.hasHeroData) return {}
      let viz = this.expandedData.execution.fixedVisualization

      if (!viz) viz = { color: this.expandedData.backgroundColor, img: this.expandedData.img }
      return {
        backgroundImage: `
                linear-gradient(to top, rgba(30, 30, 30, 1) 5%, rgba(30, 30, 30, 0.7) 40%, ${viz.color}B3 100%),
                url(${viz.img})
            `,
      }
    },
    sessionExercises() {
      if (!this.expandedData || !this.expandedData.sets) return []
      const exercises = {}
      this.expandedData.sets.forEach((set) => {
        if (!set.steps) return
        set.steps.forEach((step) => {
          if (!exercises[set.exercise_id]) {
            exercises[set.exercise_id] = { id: set.exercise_id, sets: [], totalReps: 0, totalWeight: 0 }
          }
          exercises[set.exercise_id].sets.push(step)
          exercises[set.exercise_id].totalReps += step.reps || 0
          exercises[set.exercise_id].totalWeight += (step.weight || 0) * (step.reps || 0)
        })
      })
      return Object.values(exercises)
    },
    chartData() {
      if (!this.expandedData.sets || this.expandedData.sets.length < 1) return null
      const dataByDate = {}
      this.expandedData.sets.forEach((s) => {
        const date = this.$moment(s.date).format("YYYY-MM-DD")
        if (!dataByDate[date]) dataByDate[date] = []
        if (s.steps) dataByDate[date].push(...s.steps)
      })
      const sortedDates = Object.keys(dataByDate).sort((a, b) => new Date(a) - new Date(b))
      if (sortedDates.length < 1) return null
      const volumeData = []
      const weightData = []
      sortedDates.forEach((date) => {
        const stepsOnDate = dataByDate[date]
        const totalVolume = stepsOnDate.reduce((acc, step) => acc + step.weight * step.reps, 0)
        const maxWeight = stepsOnDate.reduce((max, step) => Math.max(max, step.weight), 0)
        const formattedDate = this.$moment(date).format("DD MMM YY")
        volumeData.push({ x: formattedDate, y: totalVolume })
        weightData.push({ x: formattedDate, y: maxWeight })
      })
      return {
        volume: [{ name: "Volumen", data: volumeData }],
        weight: [{ name: "Max. Gewicht", data: weightData }],
      }
    },
    chartOptions() {
      const accentColor = this.expandedData.backgroundColor || "#00E396"
      const isVolume = this.chartMode === "volume"
      return {
        chart: { type: "area", height: 350, foreColor: "#fff", toolbar: { show: false }, zoom: { enabled: false } },
        colors: [accentColor],
        dataLabels: { enabled: false },
        stroke: { curve: "smooth", width: 3 },
        fill: { type: "gradient", gradient: { shadeIntensity: 1, opacityFrom: 0.7, opacityTo: 0.1, stops: [0, 90, 100] } },
        tooltip: { theme: "dark", x: { format: "dd MMM yy" } },
        grid: { borderColor: "rgba(255, 255, 255, 0.1)", strokeDashArray: 4 },
        legend: { show: false },
        xaxis: {
          type: "category",
          labels: { style: { colors: "#888" }, trim: true, hideOverlappingLabels: true },
          axisBorder: { show: false },
          axisTicks: { show: false },
        },
        yaxis: {
          labels: { style: { colors: "#888" }, formatter: (val) => val.toFixed(0) },
          title: { text: isVolume ? "Trainingsvolumen (kg)" : "Maximales Gewicht (kg)", style: { color: "#888", fontWeight: "normal" } },
        },
      }
    },
    containerHeight() {
      return `${this.cardHeight + this.paddingVertical * 2}px`
    },
    containerWidth() {
      if (!this.stackWidth) return `${this.cardWidth + this.paddingHorizontal * 2}px`
      if (typeof this.stackWidth === "number") return `${this.stackWidth}px`
      return this.stackWidth
    },
    _maxVisibleCards() {
      return this.maxVisibleCards > this.cards.length ? this.cards.length : this.maxVisibleCards
    },
    overlapOffset() {
      return 20
    },
    verticalStackRestPoints() {
      return this.cards.map((_, i) => this.paddingVertical + i * this.overlapOffset)
    },
    cardDefaults() {
      return this.cards.map((_, i) => {
        const baseY = this.verticalStackRestPoints[i]
        return {
          opacity: 1,
          display: "block",
          xPos: this.paddingHorizontal,
          yPos: baseY,
          scale: i === 0 ? 1 : 1 - this._scaleMultiplier,
          width: this.cardWidth,
          height: this.cardHeight,
          zIndex: this.cards.length - i,
          isDragging: this.isDragging,
        }
      })
    },
    _scaleMultiplier() {
      return 0.05
    },
    isTouch() {
      return "ontouchstart" in window
    },
    dragEvent() {
      return this.isTouch ? "touchmove" : "mousemove"
    },
    touchStartEvent() {
      return this.isTouch ? "touchstart" : "mousedown"
    },
    touchEndEvent() {
      return this.isTouch ? "touchend" : "mouseup"
    },
    originalActiveCardIndex() {
      return this.stack[this.activeCardIndex]?._index || 0
    },
  },
  methods: {
    ...mapActions("runWorkoutStore", ["setActiveSplit", "setGroupedExercises"]),
    formatDuration(totalSeconds) {
      if (isNaN(totalSeconds) || totalSeconds < 0) return totalSeconds
      const hours = Math.floor(totalSeconds / 3600)
      const minutes = Math.floor((totalSeconds % 3600) / 60)
      const seconds = Math.floor(totalSeconds % 60)

      const pad = (num) => String(num).padStart(2, "0")
      return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`
    },
    onTouchStart(e) {
      this.dragStartY = this.getDragYPos(e)
      document.addEventListener(this.dragEvent, this.onDrag)
    },
    onDrag(e) {
      const dragY = this.getDragYPos(e)
      const dragDist = Math.abs(dragY - this.dragStartY)
      if (!this.isDragging && dragDist > this.dragThreshold) {
        this.isDragging = true
      }
      if (this.isDragging) {
        this.isDraggingDown = dragY > this.dragStartY
        this.moveStack(dragY)
      }
    },
    onTouchEnd() {
      if (this.isDragging) {
        this.updateStack()
      }
      this.isDragging = false
      document.removeEventListener(this.dragEvent, this.onDrag)
    },
    getCardStyle(card) {
      return {
        display: card.display,
        width: card.width,
        height: `${card.height}px`,
        zIndex: card.zIndex,
        transition: `transform ${this.isDragging ? 0 : this.speed}s ease, opacity ${this.speed}s ease`,
        transform: `translate(0, ${card.yPos}px) scale(${card.scale})`,
        cursor: this.showClone ? "default" : "pointer",
      }
    },
    getCardBackground(card, cardIndex) {
      let bgStyle = {}
      if (this.exercises && card.exercise) {
        const imgUrl = this.getImageForExercise(card.exercise)
        if (imgUrl) {
          bgStyle.backgroundImage = `linear-gradient(180deg, rgba(0,0,0,0.7) 0%, transparent 50%, rgba(0,0,0,0.9) 100%), url('${imgUrl}')`
          bgStyle.backgroundSize = "cover"
          bgStyle.backgroundPosition = "center"
        } else {
          bgStyle.backgroundColor = `hsl(${cardIndex * 30}, 30%, 35%)`
        }
      } else {
        bgStyle.backgroundColor = card.backgroundColor || `hsl(${cardIndex * 50}, 40%, 40%)`
      }
      return bgStyle
    },
    getExercise(id) {
      return this.exerciseList.find((ex) => ex._id === id)
    },
    getImageForExercise(ex) {
      if (!ex) return ""
      if (ex.picture) return this.getImageUrl(ex.picture)
      if (ex.manual && ex.manual[0]?.picture) return this.getImageUrl(ex.manual[0].picture)
      return ""
    },
    getImageUrl(id) {
      return "/img/uebungen/" + id.replace(/\.[^/.]+$/, "") + ".webp"
    },
    init() {
      this.stack = this.cards.map((card, i) => ({ _id: Date.now() + i, _index: i, ...card, ...this.cardDefaults[i] }))
    },
    rebuild() {
      this.$nextTick(() => {
        this.stack = this.stack.map((c, i) => ({ ...c, ...this.cardDefaults[i] }))
      })
    },
    handleResize: debounce(function () {
      this.width = this.$el.clientWidth
      this.rebuild()
    }, 250),
    expandCard(idx, event) {
      const orig = event.currentTarget
      const rect = orig.getBoundingClientRect()
      this.originalCloneStyle = {
        top: `${rect.top}px`,
        left: `${rect.left}px`,
        width: `${rect.width}px`,
        height: `${rect.height}px`,
        borderRadius: getComputedStyle(orig).borderRadius,
      }
      this.expandedData = { ...this.stack[idx] }
      this.cloneStyle = {
        position: "fixed",
        top: this.originalCloneStyle.top,
        left: this.originalCloneStyle.left,
        width: this.originalCloneStyle.width,
        height: this.originalCloneStyle.height,
        zIndex: 10000,
        transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
        transformOrigin: "center",
      }
      this.cloneCardStyle = {
        backgroundColor: "transparent",
        width: "100%",
        height: "100%",
        overflow: "hidden",
        borderRadius: this.originalCloneStyle.borderRadius,
      }
      this.showClone = true
      this.$nextTick(() => {
        Object.assign(this.cloneStyle, { top: "0", left: "0", width: "100vw", height: "100vh" })
        this.cloneCardStyle.borderRadius = "0"
      })
    },
    closeClone() {
      this.isClosing = true
      this.cloneCardStyle.overflow = "hidden"
      Object.assign(this.cloneStyle, this.originalCloneStyle)
      this.cloneCardStyle.borderRadius = this.originalCloneStyle.borderRadius
    },
    onTransitionEnd() {
      if (this.isClosing) {
        this.showClone = false
        this.isClosing = false
        this.expandedData = {}
      } else if (this.showClone) {
        this.cloneCardStyle.overflow = "auto"
        this.$emit("expanded", this.expandedData)
      }
    },
    onNext() {
      this.stack.push(this.stack.shift())
      this.rebuild()
    },
    onPrevious() {
      this.stack.unshift(this.stack.pop())
      this.rebuild()
    },
    updateStack() {
      const a = this.stack[this.activeCardIndex]
      if (!a) return
      const rest = this.verticalStackRestPoints[this.activeCardIndex]
      const dist = a.yPos - rest
      const minD = (this.cardHeight + this.paddingVertical) / (1 / this.sensitivity)
      this.$emit("move", 0)
      if (this.isDraggingDown ? dist > minD : Math.abs(dist) > minD) {
        this.isDraggingDown ? this.onPrevious() : this.onNext()
      } else {
        this.rebuild()
      }
    },
    moveStack(dragY) {
      const off = dragY - this.dragStartY
      this.$emit("move", off / (this.cardHeight + this.paddingVertical))
      this.activeCardIndex = 0
      this.stack = this.stack.map((c, i) => ({
        ...c,
        ...this.cardDefaults[i],
        yPos: i === 0 ? this.cardDefaults[i].yPos + off : this.cardDefaults[i].yPos,
      }))
    },
    getDragYPos(e) {
      return this.isTouch ? e.touches[0].clientY : e.clientY
    },
  },
}
</script>
<style scoped>
/* GRUNDLAGEN & PERSÖNLICHE BESTLEISTUNGEN (aus dem Klon-Modus) */
.personal-best-card {
  background: linear-gradient(145deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.03));
  border-radius: 16px;
  padding: 16px;
  display: flex;
  align-items: center;
  transition: all 0.3s ease;
  border: 1px solid rgba(255, 255, 255, 0.1);
}
.personal-best-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
  border-color: rgba(255, 255, 255, 0.2);
}
.best-card-icon {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  margin-right: 16px;
  flex-shrink: 0;
}
.best-card-icon.trophy {
  background-color: rgba(255, 193, 7, 0.1);
  box-shadow: 0 0 15px rgba(255, 193, 7, 0.2);
}
.best-card-icon.volume {
  background-color: rgba(100, 181, 246, 0.1);
  box-shadow: 0 0 15px rgba(100, 181, 246, 0.2);
}
.glass-card {
  background-color: rgba(36, 36, 36, 0.7) !important;
  backdrop-filter: blur(25px) saturate(180%) !important;
  -webkit-backdrop-filter: blur(25px) saturate(180%) !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
}

/* Neuer, verbesserter Text-Schatten für bessere Lesbarkeit auf Bildern */
.text-on-image {
  text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.6), 0px 4px 12px rgba(0, 0, 0, 0.8);
}

.text-muted {
  color: rgba(255, 255, 255, 0.6) !important;
}

/* Stile für die geklonte/expandierte Ansicht */
.card-clone {
  background-color: #121212;
  color: white;
  overflow: hidden;
}
.background-glow {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 150vw;
  height: 150vh;
  transform: translate(-50%, -50%);
  background: radial-gradient(circle at center, var(--glow-color, #555) 0%, transparent 45%);
  filter: blur(100px);
  opacity: 0.15;
  pointer-events: none;
  z-index: -1;
  animation: pulse-glow-subtle 8s infinite alternate;
}
@keyframes pulse-glow-subtle {
  from {
    opacity: 0.15;
    transform: translate(-50%, -50%) scale(1);
  }
  to {
    opacity: 0.3;
    transform: translate(-50%, -50%) scale(1.1);
  }
}
.hero-header {
  min-height: 250px;
  padding: 72px 24px 24px 24px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
  background-size: cover;
  background-position: center center;
  position: relative;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.7);
}
.hero-content {
  animation: fade-in-up 0.8s 0.2s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
  opacity: 0;
  transform: translateY(30px);
  z-index: 2;
}
.content-wrapper {
  animation: fade-in-up 0.6s 0.2s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
  opacity: 0;
  transform: translateY(30px);
}
.stat-card-small {
  background: linear-gradient(145deg, rgba(255, 255, 255, 0.08), rgba(255, 255, 255, 0.03));
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  text-align: center;
}
.stat-emoji-small {
  font-size: 1.8rem;
  margin-bottom: 8px;
}
.stat-value-small {
  font-size: 1.2rem;
  font-weight: 700;
  color: white;
  line-height: 1.2;
}
.stat-label-small {
  font-size: 0.7rem;
  color: #bdbdbd;
}
.pr-card {
  background: linear-gradient(135deg, #333, #222);
  border: 1px solid #444;
  border-radius: 12px;
  padding: 12px 16px;
  width: 220px;
  text-align: center;
}
.pr-title {
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: white;
}
.pr-type {
  font-size: 0.8rem;
  color: #bdbdbd;
}
.pr-values {
  margin-top: 8px;
  font-size: 1.2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
}
.old-value {
  color: #9e9e9e;
  text-decoration: line-through;
}
.new-value {
  font-weight: bold;
  color: #a5d6a7;
}
.custom-panels.v-expansion-panels {
  z-index: 0;
}
.custom-panels .v-expansion-panel {
  background-color: rgba(255, 255, 255, 0.05) !important;
  border-radius: 16px !important;
  margin-bottom: 8px;
}
.custom-panels .v-expansion-panel-header {
  font-weight: bold;
}
.v-expansion-panel-content__wrap {
  padding: 0 16px 16px;
}
.transparent-table,
.transparent-table th,
.transparent-table td {
  background-color: transparent !important;
  color: white !important;
}
.transparent-table th {
  color: rgba(255, 255, 255, 0.6) !important;
}
.verlauf-card-icon {
  position: absolute;
  top: 20px;
  right: 20px;
  opacity: 0.5;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.5));
  transition: all 0.3s ease;
  pointer-events: none;
}

/* ------------------------------------------- */
/* --- NEUES, GEILES KARTEN-STYLING START --- */
/* ------------------------------------------- */

.vue-card-stack__wrapper {
  position: relative;
  touch-action: none;
}

/* Wichtig: Fügt eine 3D-Perspektive hinzu, die für den Tilt-Effekt benötigt wird. */
.vue-card-stack__stack {
  position: relative;
  overflow: hidden;
  perspective: 1500px;
}

.vue-card-stack__card {
  position: absolute;
  transform-origin: center top;
  transition: all 0.3s ease-out; /* Weicherer Übergang für Kartenwechsel */
  border-radius: 28px !important; /* Etwas runder für einen moderneren Look */
}

.card-content-wrapper {
  width: 100%;
  height: 100%;
  border-radius: 28px;
  position: relative;
  overflow: hidden;
  /* Sanfter Übergang für den Hover-Effekt und den neuen Leuchtschatten */
  transition: transform 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275), box-shadow 0.4s ease;
  will-change: transform, box-shadow; /* Performance-Optimierung für Animationen */
}

/* Style nur für die oberste, aktive Karte */
.card-content-wrapper.is-top-card {
  /* Ein subtiler, cooler Leuchteffekt basierend auf der dynamischen Farbe */
  box-shadow: 0 0 20px -8px var(--glow-color), 0 10px 20px rgba(0, 0, 0, 0.3);

  /* Der Parallax-Effekt für die inneren Elemente wird hier vorbereitet */
  transform-style: preserve-3d;
}

/* Parallax-Effekt für Titel und Text auf der obersten Karte */
.is-top-card .v-card-title,
.is-top-card .v-card-text {
  transition: transform 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

/* Der eigentliche 3D-Tilt, Skalierungs- und Leuchteffekt beim Hovern über die oberste Karte */
.vue-card-stack__card:first-child:hover .card-content-wrapper {
  transform: translateY(-10px) scale(1.05) rotateX(7deg) rotateY(3deg);
  box-shadow: 0 0 45px -10px var(--glow-color), 0 25px 40px rgba(0, 0, 0, 0.4);
}

/* Lässt den Inhalt der Karte (Titel, Text) sich leicht in die entgegengesetzte Richtung bewegen */
.vue-card-stack__card:first-child:hover .v-card-title {
  transform: translateZ(30px);
}
.vue-card-stack__card:first-child:hover .v-card-text {
  transform: translateZ(20px);
}

/* Verbesserter Shine-Effekt: größer und epischer */
.card-shine-effect::after {
  content: "";
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: linear-gradient(to right, rgba(255, 255, 255, 0) 30%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0) 70%);
  transform: translateX(-150%) rotate(25deg);
  transition: transform 1.2s cubic-bezier(0.2, 0.8, 0.2, 1);
  pointer-events: none;
}

/* Löst den Shine-Effekt beim Hovern aus */
.vue-card-stack__card:first-child:hover .card-shine-effect::after {
  transform: translateX(150%) rotate(25deg);
}

/* Stile für den Schließen-Button und andere Hilfsklassen */
.clone-close-btn {
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 10001;
}
.overflow-y-auto {
  overflow-y: auto;
}
.animated-item {
  opacity: 0;
  transform: translateY(20px);
  animation: fade-in-up 0.5s cubic-bezier(0.4, 0, 0.2, 1) forwards;
  animation-delay: var(--delay);
}
@keyframes fade-in-up {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* ------------------------------------------- */
/* --- NEUES, GEILES KARTEN-STYLING ENDE --- */
/* ------------------------------------------- */
</style>
